<template>
    <el-dialog custom-class="clearWrap" width="548px" center :visible.sync="dlg.clearCacheAct"
			:close-on-click-modal="false" :show-close="false" :close-on-press-escape="false">
			<div class="clearBox">
				<img src='@/assets/images/clearCacheBg.png'>
				<div>
					<h1>清理缓存操作</h1>
					<p v-html='getText()'></p>
				</div>
			</div>
		</el-dialog>

</template>
<script>
   export default {
    data(){
        return{
            dlg: {
					clearCacheAct:true,
            }
        }
    },
    mounted(){
        this.getText();
    },
    methods:{
        getText(){
				const ua = navigator.userAgent;

				// 判断是否是 Chrome
				const isChrome = /Chrome/.test(ua) && /Google Inc/.test(navigator.vendor);
				console.log(isChrome,'====isChrome')
				if (isChrome) {
					return '请直接按 Ctrl+Shift+Delete 组合键，<br/>弹出清理窗口，点击立即清除'
				}

				// 检测是否为 360 浏览器（特征是插件）
				const plugins = window.navigator.plugins;

				for (let i = 0; i < plugins.length; i++) {
				if (plugins[i].name.includes('360')) {
					return '请直接按 Ctrl+Shift+Delete 组合键，<br/>弹出清理窗口，点击删除数据';
				}
				}
			}
    }
        
    }
</script>
<style lang="less" scoped>
::v-deep .clearWrap{
	background: none !important;
	box-shadow: none !important;
		.el-dialog__header{
			padding:0 !important;
		}
		.el-dialog__body{
			width: 548px;
			height: 395px;
			padding:0 !important;
		}
		.clearBox{
			position:relative;
			width: 100%;
			height:100%;
			div{
				position: absolute;
				z-index: 99;
				top: 31%;
				text-align: center;
				box-sizing: border-box;
				width: 100%;
				h1 {
					font-size: 32px;
					font-weight: 500;
					margin-bottom: 50px;
					color: #202020;
				}

				p {
					font-size: 22px;
					font-weight: 500;
					color: #202020;
					line-height:40px;
				}

			}
			img{
				position:absolute;
				left:0;
				top:0;
				width: 548px;
			}
		}
	}
</style>
